import { buildLoader } from '../util/GenericLoader';
import { getUsersAndRolesAction } from '../../redux/actions/users';

export default buildLoader(getUsersAndRolesAction);
